export default __webpack_public_path__ + "static/media/react.469fe042.png";